import { isPurePrizeGames } from 'config/promoGameTypes';

export function isFulFilledEntries(
    gameType,
    {
        hasGameResult = false,
        hasFilledSignupForm = false,
        hasInstantPrize = false,
        hasParticipantPrize = false
    } = {}
) {
    if (isPurePrizeGames(gameType)) {
        // 純獎模組讓 user 配完再拿 entries 比較合理
        return [hasGameResult, hasFilledSignupForm, hasInstantPrize, hasParticipantPrize].every(
            e => e
        );
    } else {
        return [hasGameResult, hasFilledSignupForm].every(e => e);
    }
}
